import { watch } from "vue";

export default {
	unmounted(element){
		element?.unwatch?.();
	},
	mounted(element, bindings){
		let item = bindings.value;

		let parentElement = element.parentElement?.parentElement;
		if(!parentElement) return;

		handleScroll(item.active);
		element.unwatch = watch(() => item.active, handleScroll);

		function handleScroll(bool){
			if(!bool) return;
			parentElement.scrollLeft = element.offsetLeft - parentElement.offsetWidth / 2 + element.offsetWidth / 2;
		}
	},
};